import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../store/authStore';
import { Loader2 } from 'lucide-react';
import { useTranslation } from '../lib/i18n';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, setSession } = useAuthStore();
  const { t } = useTranslation();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the current session
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError) throw sessionError;

        if (!session) {
          // No session found, redirect to auth page
          navigate('/auth', { replace: true });
          return;
        }

        // Update global auth state
        setSession(session);
        setUser(session.user);

        // User profile is automatically created by database trigger

        // Redirect to home page
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Error handling auth callback:', error);
        navigate('/auth', { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate, setUser, setSession, t]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 animate-spin text-blue-500 mx-auto" />
        <p className="text-lg font-medium">{t('authCallback.completing')}</p>
        <p className="text-sm text-gray-500">{t('authCallback.waiting')}</p>
      </div>
    </div>
  );
};

export default AuthCallback;